import API from "@aws-amplify/api";
import { getCurrentJwt } from "../../../../util/jwt/decryptToken";
import CryptoJS from "crypto-js";

export async function fetchSelections() {
  const options = {
    headers: {
      cname: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("logoName"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
      Authorization: getCurrentJwt()
    },
    body: {
    },
  };

  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await API.get(process.env.REACT_APP_AMPLIFY_API, '/selections', options).then(data => data)
      return res
    }
    catch (e) {
      console.log(e)
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/dataFetches/fetchSelection.js